export default __webpack_public_path__ + "static/media/banner-f.0e341027.png";